exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-button-toggle-checked {\n    color: #00A8c6;\n    background-color: #ffffff;\n    border-radius: 5px;\n    border: #00A8c6 1px solid;\n}\n\n.mat-button-toggle-group.form-control {\n    border-radius: 5px;\n    padding: 1px 5px;\n    box-shadow: none;\n}\n\n.mat-button-toggle-label>.mat-button-toggle-label-content {\n    line-height: 30px;\n    font-weight: 300px;\n}\n\n.mat-card {\n    margin-bottom: 3px;\n}\n\n.hint {\n    padding-right: 9px;\n    text-decoration: underline;\n}\n\n\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/shared/components/extend-shift-dialog/extend-shift-dialog.component.css
// module id = ../../../../../src/app/shared/components/extend-shift-dialog/extend-shift-dialog.component.css
// module chunks = main